// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_PGQ","cls2":"PodcastLibraryCarouselAd-cls2_4n6 PodcastLibraryCarouselAd-cls1_PGQ"};